import React from 'react';
import { useState } from 'react';

import { isJobEvent } from '@libs/EventTypes';

import { useLayoutContext } from '@contexts/LayoutContext';

import { useContactsSelector } from '@components/ContactsSelector/Common/ContactsSelectorContext';
import ModelsTable from '@components/ContactsSelector/ModelsSelector/ModelsWall/ModelsTable/ModelsTable';
import ModelsTableAddAllModelsButton from '@components/ContactsSelector/ModelsSelector/ModelsWall/ModelsTable/ModelsTableAddAllModelsButton';
import CenteredBlock from '@components/Gui/CenteredBlock';
import EmptyState from '@components/Gui/EmptyState';
import { Loading } from '@components/Gui/Loading';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';

import { WallContainer } from './ModelsTableUI';

const ModelsTableWrapper = ({
    footer,
    isLoading,
    models,
    //packageGroup
}) => {
    const { context, layout } = useContactsSelector();
    const { currentEvent, scope } = context;

    const layoutContext = useLayoutContext();
    const { isMobile } = layoutContext;

    const isEventJob = currentEvent && isJobEvent(currentEvent.TypeName);

    const [addModelsAs, setAddModelsAs] = useState(isEventJob && currentEvent.Confirmed === 2 ? 10 : 0);

    return (
        <>
            <WallContainer>
                {isLoading ? (
                    <Loading loadingType="centered" />
                ) : models.length ? (
                    <NwCard className="modeltable-card-wrapper" padding={layout.drawer && !isMobile ? 'no' : ''}>
                        {scope === 'event' &&
                            (isEventJob ? (
                                <div className="add-models-as">
                                    add models as &nbsp;&nbsp;
                                    <RadioButtonGroup
                                        buttonStyle="solid"
                                        value={addModelsAs}
                                        options={[
                                            { key: 0, value: 0, label: 'option' },
                                            { key: 10, value: 10, label: 'confirmed' },
                                        ]}
                                        onChange={(value) => {
                                            setAddModelsAs(value);
                                        }}
                                    />
                                </div>
                            ) : (
                                <div className="add-all-models">
                                    <ModelsTableAddAllModelsButton models={models} />
                                </div>
                            ))}
                        <ModelsTable
                            list={models}
                            //packageGroup={packageGroup}
                            addModelsAs={addModelsAs}
                        />
                    </NwCard>
                ) : (
                    <CenteredBlock>
                        <EmptyState message="no models fitting your search" />
                    </CenteredBlock>
                )}
            </WallContainer>
            {footer}
        </>
    );
};

export default ModelsTableWrapper;
